import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { Plus, ArrowLeft } from 'lucide-react'
import axios from '../../lib/axios'
import '../Pages.css'

export default function CreateTemplate() {
  const [templateName, setTemplateName] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!templateName.trim()) {
      setError('Please enter a template name')
      return
    }

    const payload = {
      html: '<p></p>',
      subject: 'Enter Subject',
      html_json: {},
      name: templateName
    }

    try {
      setLoading(true)
      setError('')
      const response = await axios.post('master-templates/create', payload)

      if (response.data && response.data.id) {
        navigate(`/templates/edit/${response.data.id}`)
      }
    } catch (err) {
      console.error('Error creating template:', err)
      setError('Failed to create template. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page create-template-page animate-fade-in">
      <div className="page-header">
        <div className="header-info">
          <h2>Create New Template</h2>
          <p>Start building your email template</p>
        </div>
        <Link to="/templates" className="btn btn-ghost">
          <ArrowLeft size={18} />
          <span>Back to Templates</span>
        </Link>
      </div>

      <div className="card">
        <div className="modal-form">
          <form onSubmit={handleSubmit}>
            {error && (
              <div style={{
                padding: '1rem',
                marginBottom: '1.5rem',
                background: 'rgba(239, 68, 68, 0.1)',
                border: '1px solid rgba(239, 68, 68, 0.3)',
                borderRadius: 'var(--radius-md)',
                color: 'var(--color-error)'
              }}>
                {error}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="templateName">
                Template Name <span style={{ color: 'var(--color-error)' }}>*</span>
              </label>
              <input
                id="templateName"
                type="text"
                placeholder="Enter template name (e.g., Welcome Email, Newsletter)"
                value={templateName}
                onChange={(e) => {
                  setTemplateName(e.target.value)
                  setError('')
                }}
                className={error ? 'error' : ''}
                disabled={loading}
                autoFocus
              />
              {error && <div className="error-message">{error}</div>}
            </div>

            <div style={{ display: 'flex', gap: '0.75rem', marginTop: '2rem' }}>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading || !templateName.trim()}
                style={{ flex: 1 }}
              >
                <Plus size={18} />
                <span>{loading ? 'Creating...' : 'Create Template'}</span>
              </button>
              <Link to="/templates" className="btn btn-secondary">
                Cancel
              </Link>
            </div>
          </form>
        </div>
      </div>

      <div style={{
        marginTop: '1.5rem',
        padding: '1rem',
        background: 'var(--color-bg-card)',
        border: '1px solid var(--color-border)',
        borderRadius: 'var(--radius-lg)'
      }}>
        <h3 style={{ fontSize: '0.9rem', fontWeight: '600', marginBottom: '0.75rem' }}>
          What's next?
        </h3>
        <ul style={{ paddingLeft: '1.25rem', color: 'var(--color-text-secondary)', fontSize: '0.85rem', lineHeight: '1.6' }}>
          <li>After creating, you'll be redirected to the email builder</li>
          <li>Design your template using the drag-and-drop editor</li>
          <li>Add subject line and customize content</li>
          <li>Save your template to use in campaigns</li>
        </ul>
      </div>
    </div>
  )
}
